<template>
  <div>
    <commonModal
      :show="showMoreInfoModal"
      :options="{
        title: 'More Information',
        description: `If you choose to exclude ${
          id === 2 ? 'your spouse' : 'this person'
        }, this policy will not
          provide any coverage if ${
            id === 2 ? 'your spouse' : 'this person'
          } is involved in an accident
          while driving a vehicle listed on this policy. Even if you would
          like to exclude ${
            id === 2 ? 'your spouse' : 'this person'
          } from your policy, you will need to
          provide some basic information about them for our records.`,
        buttonLabel: 'OK'
      }"
      @close="showMoreInfoModal = false"
    ></commonModal>
    <commonModal
      :show="licenseStatusWarningModal"
      :options="{
        title: 'Sorry!',
        description: `Unfortunately we cannot provide coverage for drivers with a revoked or suspended driver’s license.`,
        buttonLabel: 'OK'
      }"
      @close="licenseStatusWarningModal = false"
    ></commonModal>
    <form class="has-placeholders">
      <fieldset>
        <div v-for="(driver, index) in form.drivers" :key="driver.id">
          <div v-if="driver.id === id" class="driver">
            <legend>{{ driver.name }}</legend>
            <div
              v-if="driver.relation !== 'Spouse'"
              class="columns is-variable is-8-widescreen"
            >
              <div class="column is-half padd-bottom-0">
                <label class="input -spacing-static-c">
                  <input
                    :class="{
                      input__field: true,
                      error: errors.has('firstName' + driver.id)
                    }"
                    :name="'firstName' + driver.id"
                    type="text"
                    placeholder="First Name"
                    v-model="driver.firstName"
                    v-validate="'required'"
                    maxlength="63"
                    :disabled="driver.id === 1"
                  />
                  <span class="input__label">First Name</span>
                </label>
                <label class="input -spacing-static-c">
                  <input
                    :class="{
                      input__field: true,
                      error: errors.has('lastName' + driver.id)
                    }"
                    :name="'lastName' + driver.id"
                    type="text"
                    placeholder="Last Name"
                    v-model="driver.lastName"
                    v-validate="'required'"
                    maxlength="63"
                    :disabled="driver.id === 1"
                  />
                  <span class="input__label">Last Name</span>
                </label>

                <label class="input -spacing-static-c" v-if="index === 0">
                  <input
                    :class="{
                      input__field: true,
                      error: errors.has('emailAddress' + driver.id)
                    }"
                    :name="'emailAddress' + driver.id"
                    type="email"
                    placeholder="Email Address"
                    v-model="driver.emailAddress"
                    v-validate="'required|email'"
                  />
                  <span class="input__label">Email Address</span>
                </label>
                <div class="limit-container" v-if="index > 0">
                  <label class="input -spacing-static-c">
                    <masked-input
                      :class="{
                        input__field: true,
                        error: errors.has('dateOfBirth' + driver.id)
                      }"
                      :name="'dateOfBirth' + driver.id"
                      placeholder="Date of birth (MM/DD/YYYY)"
                      v-model="driver.dateOfBirth"
                      :keepCharPositions="true"
                      v-validate="'required|validate16YrsOld|isLeapYear'"
                      :placeholderChar="'_'"
                      @blur="
                        checkWorking(
                          'dateOfBirth' + driver.id,
                          driver.dateOfBirth
                        )
                      "
                      :pipe="autoCorrectedDatePipe"
                      :mask="[
                        /\d/,
                        /\d/,
                        '/',
                        /\d/,
                        /\d/,
                        '/',
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/
                      ]"
                      :guide="true"
                    ></masked-input>
                    <span class="input__label">Date of birth (MM/DD/YYYY)</span>
                  </label>
                  <b-icon
                    pack="fas"
                    icon="calendar"
                    class="calendar-icon"
                  ></b-icon>
                  <b-datepicker
                    name="date1"
                    @input="changedDOB"
                    v-model="selectedDate"
                    :max-date="validationOptions.atleastSixteenYrsOld"
                    :min-date="validationOptions.someOldDate"
                    :focused-date="validationOptions.atleastSixteenYrsOld"
                    :mobile-native="false"
                  ></b-datepicker>
                </div>
                <div class="select-wrapper -spacing-static-c">
                  <label
                    :for="'gender' + driver.id"
                    :class="{
                      error: errors.has('gender' + driver.id)
                    }"
                    >Gender</label
                  >
                  <v-select
                    v-model="driver.gender"
                    :searchable="false"
                    :options="selectsDrivers.gender"
                    v-validate="'required'"
                    :name="'gender' + driver.id"
                    :class="{ error: errors.has('gender' + driver.id) }"
                  ></v-select>
                </div>

                <div
                  class="select-wrapper -spacing-static-c"
                  v-if="index === 0"
                >
                  <label
                    :for="'maritalStatus' + driver.id"
                    :class="{
                      error: errors.has('maritalStatus' + driver.id)
                    }"
                    >Marital Status</label
                  >
                  <v-select
                    v-model="driver.maritalStatus"
                    :searchable="false"
                    :options="selectsDrivers.maritalStatus"
                    v-validate="'required'"
                    @input="maritalStatusChanged"
                    :name="'maritalStatus' + driver.id"
                    :class="{ error: errors.has('maritalStatus' + driver.id) }"
                    data-vv-validate-on="input|blur"
                  ></v-select>
                </div>

                <div
                  class="select-wrapper -spacing-static-c"
                  v-if="index === 0"
                >
                  <label
                    :for="'licenseState' + driver.id"
                    :class="{
                      error: errors.has('licenseState' + driver.id)
                    }"
                    >License State</label
                  >
                  <v-select
                    v-model="driver.licenseState"
                    :searchable="true"
                    :options="selectsDrivers.licenseStates"
                    v-validate="'required'"
                    @input="licenseStateChanged"
                    :name="'licenseState' + driver.id"
                    :class="{ error: errors.has('licenseState' + driver.id) }"
                    data-vv-validate-on="input|blur"
                  ></v-select>
                </div>

                <div
                  class="select-wrapper -spacing-static-c"
                  v-if="index === 0"
                >
                  <label
                    :for="'licenseStatus' + driver.id"
                    :class="{
                      error: errors.has('licenseStatus' + driver.id)
                    }"
                    >License Status</label
                  >
                  <v-select
                    v-model="driver.licenseStatus"
                    :searchable="false"
                    :options="selectsDrivers.licenseStatus"
                    v-validate="'required'"
                    :name="'licenseStatus' + driver.id"
                    :class="{ error: errors.has('licenseStatus' + driver.id) }"
                  ></v-select>
                </div>

                <label class="input -spacing-static-c" v-if="index === 0">
                  <input
                    :class="{
                      input__field: true,
                      'fs-block': true,
                      error:
                        errors.has('licenseNum' + driver.id) ||
                        isDuplicateLicenseNum
                    }"
                    :name="'licenseNum' + driver.id"
                    @input="licenseNumChange"
                    placeholder="Driver's License Number"
                    v-model="driver.licenseNum"
                    v-validate="driver.DLValidation"
                    data-vv-validate-on="input|blur"
                  />
                  <span class="input__label">Driver's License Number</span>
                </label>

                <div class="select-wrapper -spacing-static-c" v-if="index > 0">
                  <label
                    :for="'relation' + driver.id"
                    :class="{
                      error: errors.has('relation' + driver.id)
                    }"
                    >Relation to Primary Driver</label
                  >
                  <v-select
                    v-model="driver.relation"
                    :searchable="false"
                    :options="selectsDrivers.relation"
                    v-validate="'required'"
                    :name="'relation' + driver.id"
                    :class="{ error: errors.has('relation' + driver.id) }"
                  ></v-select>
                </div>

                <div class="select-wrapper -spacing-static-c" v-if="index > 0">
                  <label
                    :for="'maritalStatus' + driver.id"
                    :class="{
                      error: errors.has('maritalStatus' + driver.id)
                    }"
                    >Marital Status</label
                  >
                  <v-select
                    v-model="driver.maritalStatus"
                    :searchable="false"
                    :options="selectsDrivers.maritalStatus"
                    v-validate="'required'"
                    :name="'maritalStatus' + driver.id"
                    @input="maritalStatusChanged"
                    :class="{ error: errors.has('maritalStatus' + driver.id) }"
                    data-vv-validate-on="input|blur"
                  ></v-select>
                </div>
                <div
                  v-if="occupationState"
                  class="select-wrapper -spacing-static-c"
                >
                  <label
                    :for="'occupationIndustry' + driver.id"
                    :class="{
                      error: errors.has('occupationIndustry' + driver.id)
                    }"
                    >Occupation</label
                  >
                  <v-select
                    v-model="driver.occupationIndustry"
                    :searchable="true"
                    :options="industrySelects"
                    v-validate="'required'"
                    placeholder="Industry"
                    v-on:change="industryChange"
                    :name="'occupationIndustry' + driver.id"
                    :class="{
                      error: errors.has('occupationIndustry' + driver.id)
                    }"
                  ></v-select>
                </div>
                <div
                  v-if="
                    occupationState &&
                      occupationSelect.length > 0 &&
                      !!driver.occupationIndustry
                  "
                  class="select-wrapper -spacing-static-c"
                >
                  <v-select
                    v-model="driver.occupation"
                    v-on:change="occupationChange"
                    :searchable="true"
                    :options="occupationSelect"
                    v-validate="'required'"
                    placeholder="Occupation"
                    :name="'occupation' + driver.id"
                    :disabled="occupationReadonly"
                    :class="{
                      disabled: occupationReadonly,
                      error: errors.has('occupation' + driver.id)
                    }"
                  ></v-select>
                </div>
                <label
                  v-else-if="
                    occupationState &&
                      occupationSelect.length === 0 &&
                      !!driver.occupationIndustry
                  "
                  class="input -spacing-static-c"
                >
                  <input
                    type="text"
                    v-model="driver.occupation"
                    v-validate="'required'"
                    placeholder="Occupation"
                    :name="'occupation' + driver.id"
                    :class="{
                      input__field: true,
                      error: errors.has('occupation' + driver.id)
                    }"
                  />
                  <span class="input__label">Occupation</span>
                </label>
              </div>

              <div class="column is-half padd-top-0">
                <div class="select-wrapper -spacing-static-c" v-if="index > 0">
                  <label
                    :for="'licenseState' + driver.id"
                    :class="{
                      error: errors.has('licenseState' + driver.id)
                    }"
                    >License State</label
                  >
                  <v-select
                    v-model="driver.licenseState"
                    :searchable="true"
                    :options="selectsDrivers.licenseStates"
                    @input="licenseStateChanged"
                    v-validate="'required'"
                    :name="'licenseState' + driver.id"
                    :class="{ error: errors.has('licenseState' + driver.id) }"
                    data-vv-validate-on="input|blur"
                  ></v-select>
                </div>

                <div class="select-wrapper -spacing-static-c" v-if="index > 0">
                  <label
                    :for="'licenseStatus' + driver.id"
                    :class="{
                      error: errors.has('licenseStatus' + driver.id)
                    }"
                    >License Status</label
                  >
                  <v-select
                    v-model="driver.licenseStatus"
                    :searchable="false"
                    :options="selectsDrivers.licenseStatus"
                    v-validate="'required'"
                    :name="'licenseStatus' + driver.id"
                    :class="{ error: errors.has('licenseStatus' + driver.id) }"
                  ></v-select>
                </div>

                <label class="input -spacing-static-c" v-if="index > 0">
                  <input
                    :class="{
                      input__field: true,
                      'fs-block': true,
                      error:
                        errors.has('licenseNum' + driver.id) ||
                        isDuplicateLicenseNum
                    }"
                    :name="'licenseNum' + driver.id"
                    @input="licenseNumChange"
                    placeholder="Driver's License Number"
                    v-model="driver.licenseNum"
                    v-validate="driver.DLValidation"
                    data-vv-validate-on="input|blur"
                  />
                  <span class="input__label">Driver's License Number</span>
                </label>

                <div
                  class="select-wrapper -spacing-static-c"
                  v-if="index === 0"
                >
                  <label
                    :for="'homeRentalStatus' + driver.id"
                    :class="{
                      error: errors.has('homeRentalStatus' + driver.id)
                    }"
                    >Do you own or rent your home?</label
                  >
                  <v-select
                    v-model="driver.homeRentalStatus"
                    :searchable="false"
                    :options="selectsDrivers.homeRentalStatus"
                    v-validate="'required'"
                    :name="'homeRentalStatus' + driver.id"
                    :class="{
                      error: errors.has('homeRentalStatus' + driver.id)
                    }"
                  ></v-select>
                </div>

                <div class="select-wrapper -spacing-static-c">
                  <label
                    :for="'levelOfEducation' + driver.id"
                    :class="{
                      error: errors.has('levelOfEducation' + driver.id)
                    }"
                    >Level of Education</label
                  >
                  <v-select
                    v-model="driver.levelOfEducation"
                    :searchable="false"
                    :options="selectsDrivers.levelOfEducation"
                    v-validate="'required'"
                    :name="'levelOfEducation' + driver.id"
                    :class="{
                      error: errors.has('levelOfEducation' + driver.id)
                    }"
                  ></v-select>
                </div>
                <div
                  class="select-wrapper -spacing-static-c"
                  v-if="index === 0"
                >
                  <label
                    :for="'hasAutoInsurance' + driver.id"
                    :class="{
                      error: errors.has('hasAutoInsurance' + driver.id)
                    }"
                    >Do you currently have auto insurance?</label
                  >
                  <v-select
                    v-model="driver.hasAutoInsurance"
                    :searchable="false"
                    :options="selectsDrivers.autoInsurance"
                    @input="autoInsuranceChanged(index)"
                    v-validate="'required'"
                    :name="'hasAutoInsurance' + driver.id"
                    :class="{
                      error: errors.has('hasAutoInsurance' + driver.id),
                      longOptions: true
                    }"
                    data-vv-validate-on="input|blur"
                  ></v-select>
                </div>
                <div
                  class="select-wrapper -spacing-static-c"
                  v-if="
                    occupationState &&
                      index === 0 &&
                      driver.showLengthWithInsurer
                  "
                >
                  <label
                    :for="'previousCompany' + driver.id"
                    :class="{
                      error: errors.has('previousCompany' + driver.id)
                    }"
                    >Who is Your Current/Previous Insurance Provider?</label
                  >
                  <v-select
                    v-model="form.previousCompany"
                    :searchable="false"
                    :options="previousCompanySelects"
                    v-validate="'required'"
                    :name="'previousCompany' + driver.id"
                    :class="{
                      error: errors.has('previousCompany' + driver.id),
                      longOptions: true
                    }"
                    data-vv-validate-on="input|blur"
                  ></v-select>
                </div>

                <div
                  class="select-wrapper -spacing-static-c"
                  v-if="driver.showLengthWithInsurer && index === 0"
                >
                  <label
                    :for="'recentIssuerLength' + driver.id"
                    :class="{
                      error: errors.has('recentIssuerLength' + driver.id)
                    }"
                    >{{ recentIssuerLabel }}</label
                  >
                  <v-select
                    v-model="driver.recentIssuerLength"
                    :searchable="false"
                    v-validate="'required'"
                    :options="selectsDrivers.recentIssuerLengths"
                    :name="'recentIssuerLength' + driver.id"
                    :class="{
                      error: errors.has('recentIssuerLength' + driver.id)
                    }"
                  ></v-select>
                </div>
                <div
                  class="limit-container"
                  v-if="driver.showLengthWithInsurer && index === 0"
                >
                  <label class="input -spacing-static-c">
                    <masked-input
                      :class="{
                        input__field: true,
                        error: errors.has('previousExpirationDate' + driver.id)
                      }"
                      type="text"
                      :name="'previousExpirationDate' + driver.id"
                      placeholder="When does your current policy expire?"
                      v-model="driver.previousExpirationDate"
                      :keepCharPositions="true"
                      @blur="
                        checkWorking(
                          'previousExpirationDate' + driver.id,
                          driver.previousExpirationDate
                        )
                      "
                      v-validate="policyExpValidation"
                      :pipe="autoCorrectedDatePipe"
                      :placeholderChar="'_'"
                      :mask="[
                        /\d/,
                        /\d/,
                        '/',
                        /\d/,
                        /\d/,
                        '/',
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/
                      ]"
                      :guide="true"
                    ></masked-input>
                    <span class="input__label"
                      >When does your current policy expire?</span
                    >
                  </label>
                  <b-icon
                    pack="fas"
                    icon="calendar"
                    class="calendar-icon"
                  ></b-icon>
                  <b-datepicker
                    name="date2"
                    @input="changedPreviousExpirationDate"
                    v-model="selectedDate"
                    :min-date="policyExpMinDate"
                    :max-date="policyExpMaxDate"
                    :mobile-native="false"
                  ></b-datepicker>
                </div>
                <div
                  class="select-wrapper -spacing-static-c"
                  v-if="driver.showLengthWithInsurer && index === 0"
                >
                  <label
                    :for="'recentCoverageLimits' + driver.id"
                    :class="{
                      error: errors.has('recentCoverageLimits' + driver.id)
                    }"
                    >What are/were your liability coverage limits?</label
                  >
                  <v-select
                    v-if="recentCoverageLimitsSelects"
                    v-model="driver.recentCoverageLimits"
                    :searchable="false"
                    :options="recentCoverageLimitsSelects"
                    v-validate="'required'"
                    :name="'recentCoverageLimits' + driver.id"
                    :class="{
                      error: errors.has('recentCoverageLimits' + driver.id)
                    }"
                  ></v-select>
                  <v-select
                    v-else
                    v-model="driver.recentCoverageLimits"
                    :searchable="false"
                    :options="selectsDrivers.recentCoverageLimits"
                    v-validate="'required'"
                    :name="'recentCoverageLimits' + driver.id"
                    :class="{
                      error: errors.has('recentCoverageLimits' + driver.id)
                    }"
                  ></v-select>
                </div>

                <div class="select-wrapper -spacing-static-c">
                  <label
                    :for="'accidentsConvictions' + driver.id"
                    :class="{
                      error: errors.has('accidentsConvictions' + driver.id)
                    }"
                    >Any at-fault accidents or convictions in the Last 3
                    years?</label
                  >
                  <v-select
                    v-model="driver.accidentsConvictions"
                    :searchable="false"
                    :options="selectsDrivers.accidentsConvictions"
                    v-validate="'required'"
                    :name="'accidentsConvictions' + driver.id"
                    :class="{
                      error: errors.has('accidentsConvictions' + driver.id)
                    }"
                  ></v-select>
                </div>
                <div
                  class="select-wrapper -spacing-static-c"
                  v-if="
                    ((driver.id === form.drivers.length &&
                      (!driver.maritalStatus ||
                        (driver.maritalStatus &&
                          driver.maritalStatus !== 'Married'))) ||
                      (form.drivers.length === 1 &&
                        (!driver.maritalStatus ||
                          (driver.maritalStatus &&
                            driver.maritalStatus !== 'Married')))) &&
                      !hasMaximum
                  "
                >
                  <label
                    :for="'addAnotherDriver' + driver.id"
                    :class="{
                      error: errors.has('addAnotherDriver' + driver.id)
                    }"
                    >Would you like to add another driver to this policy?</label
                  >
                  <v-select
                    v-model="driver.addAnotherDriver"
                    :searchable="false"
                    :options="selectsDrivers.addAnotherDriver"
                    :name="'addAnotherDriver' + driver.id"
                    v-validate="'required'"
                    :class="{
                      error: errors.has('addAnotherDriver' + driver.id)
                    }"
                  ></v-select>
                </div>
              </div>
            </div>
            <div v-if="driver.relation === 'Spouse'">
              <div class="columns is-variable is-8-widescreen">
                <div class="column is-half">
                  <div class="select-wrapper -spacing-static-c">
                    <label
                      :for="'excludeSpouse' + driver.id"
                      :class="{
                        error: errors.has('excludeSpouse' + driver.id)
                      }"
                    >
                      {{
                        driver.id === 2
                          ? 'Do you want to exclude your spouse from this policy?'
                          : 'Do you want to exclude this person from the policy?'
                      }}
                      <span
                        @click="openMoreInfoModal()"
                        class="more-info-link tool-tip"
                        >More info.</span
                      >
                    </label>
                    <v-select
                      v-model="driver.isExcluded"
                      :searchable="false"
                      :options="selectsDrivers.excludeSpouseOptions"
                      :name="'excludeSpouse' + driver.id"
                      :class="{
                        error: errors.has('excludeSpouse' + driver.id)
                      }"
                    ></v-select>
                  </div>

                  <label class="input -spacing-static-c">
                    <input
                      :class="{
                        input__field: true,
                        error: errors.has('firstName' + driver.id)
                      }"
                      :name="'firstName' + driver.id"
                      type="text"
                      placeholder="First Name"
                      v-model="driver.firstName"
                      v-validate="'required'"
                      maxlength="63"
                    />
                    <span class="input__label">First Name</span>
                  </label>

                  <label class="input -spacing-static-c">
                    <input
                      :class="{
                        input__field: true,
                        error: errors.has('lastName' + driver.id)
                      }"
                      :name="'lastName' + driver.id"
                      type="text"
                      placeholder="Last Name"
                      v-model="driver.lastName"
                      v-validate="'required'"
                      maxlength="63"
                    />
                    <span class="input__label">Last Name</span>
                  </label>
                  <div class="limit-container" v-if="!driver.isExcluded.value">
                    <label class="input -spacing-static-c">
                      <masked-input
                        :class="{
                          input__field: true,
                          error: errors.has('dateOfBirth' + driver.id)
                        }"
                        :name="'dateOfBirth' + driver.id"
                        placeholder="Date of birth (MM/DD/YYYY)"
                        v-model="driver.dateOfBirth"
                        :keepCharPositions="true"
                        v-validate="'required|validate18YrsOld|isLeapYear'"
                        @blur="
                          checkWorking(
                            'dateOfBirth' + driver.id,
                            driver.dateOfBirth
                          )
                        "
                        :placeholderChar="'_'"
                        :pipe="autoCorrectedDatePipe"
                        :mask="[
                          /\d/,
                          /\d/,
                          '/',
                          /\d/,
                          /\d/,
                          '/',
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/
                        ]"
                        :guide="true"
                      ></masked-input>
                      <span class="input__label"
                        >Date of birth (MM/DD/YYYY)</span
                      >
                    </label>
                    <b-icon
                      pack="fas"
                      icon="calendar"
                      class="calendar-icon"
                    ></b-icon>
                    <b-datepicker
                      name="date3"
                      @input="changedDOB"
                      v-model="selectedDate"
                      :max-date="validationOptions.atleastEighteenYrsOld"
                      :min-date="validationOptions.someOldDate"
                      :focused-date="validationOptions.atleastEighteenYrsOld"
                      :mobile-native="false"
                    ></b-datepicker>
                  </div>
                  <div class="select-wrapper -spacing-static-c">
                    <label
                      :for="'gender' + driver.id"
                      :class="{
                        error: errors.has('gender' + driver.id)
                      }"
                      >Gender</label
                    >
                    <v-select
                      v-model="driver.gender"
                      :searchable="false"
                      :options="selectsDrivers.gender"
                      v-validate="'required'"
                      :name="'gender' + driver.id"
                      :class="{ error: errors.has('gender' + driver.id) }"
                    ></v-select>
                  </div>

                  <div
                    class="select-wrapper -spacing-static-c"
                    v-if="!driver.isExcluded.value"
                  >
                    <label
                      :for="'levelOfEducation' + driver.id"
                      :class="{
                        error: errors.has('levelOfEducation' + driver.id)
                      }"
                      >Level of Education</label
                    >
                    <v-select
                      v-model="driver.levelOfEducation"
                      :searchable="false"
                      :options="selectsDrivers.levelOfEducation"
                      v-validate="'required'"
                      :name="'levelOfEducation' + driver.id"
                      :class="{
                        error: errors.has('levelOfEducation' + driver.id)
                      }"
                    ></v-select>
                  </div>

                  <div
                    v-if="occupationState"
                    class="select-wrapper -spacing-static-c"
                  >
                    <label
                      :for="'occupationIndustry' + driver.id"
                      :class="{
                        error: errors.has('occupationIndustry' + driver.id)
                      }"
                      >Occupation</label
                    >
                    <v-select
                      v-model="driver.occupationIndustry"
                      :searchable="true"
                      :options="industrySelects"
                      v-validate="'required'"
                      placeholder="Industry"
                      v-on:change="industryChange"
                      :name="'occupationIndustry' + driver.id"
                      :class="{
                        error: errors.has('occupationIndustry' + driver.id)
                      }"
                    ></v-select>
                  </div>
                  <div
                    v-if="
                      occupationState &&
                        occupationSelect.length > 0 &&
                        !!driver.occupationIndustry
                    "
                    class="select-wrapper -spacing-static-c"
                  >
                    <v-select
                      v-model="driver.occupation"
                      v-on:change="occupationChange"
                      :searchable="true"
                      :options="occupationSelect"
                      v-validate="'required'"
                      placeholder="Occupation"
                      :name="'occupation' + driver.id"
                      :disabled="occupationReadonly"
                      :class="{
                        disabled: occupationReadonly,
                        error: errors.has('occupation' + driver.id)
                      }"
                    ></v-select>
                  </div>
                  <label
                    v-else-if="
                      occupationState &&
                        occupationSelect.length === 0 &&
                        !!driver.occupationIndustry
                    "
                    class="input -spacing-static-c"
                  >
                    <input
                      type="text"
                      v-model="driver.occupation"
                      v-validate="'required'"
                      placeholder="Occupation"
                      :name="'occupation' + driver.id"
                      :class="{
                        input__field: true,
                        error: errors.has('occupation' + driver.id)
                      }"
                    />
                    <span class="input__label">Occupation</span>
                  </label>
                </div>
                <div class="column is-half">
                  <div class="select-wrapper -spacing-static-c">
                    <label
                      :for="'relation' + driver.id"
                      :class="{
                        error: errors.has('relation' + driver.id)
                      }"
                      >Relation to
                      {{
                        driver.name === 'Your Spouse' ? 'Primary' : 'Additional'
                      }}
                      Driver</label
                    >
                    <v-select
                      v-model="driver.relation"
                      :searchable="false"
                      v-validate="'required'"
                      :name="'relation' + driver.id"
                      :class="{
                        error: errors.has('relation' + driver.id)
                      }"
                      disabled
                    ></v-select>
                  </div>
                  <div class="limit-container" v-if="driver.isExcluded.value">
                    <label class="input -spacing-static-c">
                      <masked-input
                        :class="{
                          input__field: true,
                          error: errors.has('dateOfBirth' + driver.id)
                        }"
                        type="text"
                        :name="'dateOfBirth' + driver.id"
                        placeholder="Date of birth (MM/DD/YYYY)"
                        v-model="driver.dateOfBirth"
                        :keepCharPositions="true"
                        v-validate="'required|validate18YrsOld|isLeapYear'"
                        :placeholderChar="'_'"
                        @blur="
                          checkWorking(
                            'dateOfBirth' + driver.id,
                            driver.dateOfBirth
                          )
                        "
                        :pipe="autoCorrectedDatePipe"
                        :mask="[
                          /\d/,
                          /\d/,
                          '/',
                          /\d/,
                          /\d/,
                          '/',
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/
                        ]"
                        :guide="true"
                      ></masked-input>
                      <span class="input__label"
                        >Date of birth (MM/DD/YYYY)</span
                      >
                    </label>
                    <b-icon
                      pack="fas"
                      icon="calendar"
                      class="calendar-icon"
                    ></b-icon>
                    <b-datepicker
                      name="date4"
                      @input="changedDOB"
                      v-model="selectedDate"
                      :max-date="validationOptions.atleastEighteenYrsOld"
                      :min-date="validationOptions.someOldDate"
                      :focused-date="validationOptions.atleastEighteenYrsOld"
                      :mobile-native="false"
                    ></b-datepicker>
                  </div>
                  <div
                    class="select-wrapper -spacing-static-c"
                    v-if="!driver.isExcluded.value"
                  >
                    <label
                      :for="'licenseState' + driver.id"
                      :class="{
                        error: errors.has('licenseState' + driver.id)
                      }"
                      >License State</label
                    >
                    <v-select
                      v-model="driver.licenseState"
                      :searchable="true"
                      :options="selectsDrivers.licenseStates"
                      @input="licenseStateChanged"
                      v-validate="'required'"
                      :name="'licenseState' + driver.id"
                      :class="{ error: errors.has('licenseState' + driver.id) }"
                      data-vv-validate-on="input|blur"
                    ></v-select>
                  </div>

                  <div
                    class="select-wrapper -spacing-static-c"
                    v-if="!driver.isExcluded.value"
                  >
                    <label
                      :for="'licenseStatus' + driver.id"
                      :class="{
                        error: errors.has('licenseStatus' + driver.id)
                      }"
                      >License Status</label
                    >
                    <v-select
                      v-model="driver.licenseStatus"
                      :searchable="false"
                      :options="selectsDrivers.licenseStatus"
                      v-validate="'required'"
                      :name="'licenseStatus' + driver.id"
                      :class="{
                        error: errors.has('licenseStatus' + driver.id)
                      }"
                    ></v-select>
                  </div>

                  <label
                    class="input -spacing-static-c"
                    v-if="!driver.isExcluded.value"
                  >
                    <input
                      :class="{
                        input__field: true,
                        'fs-block': true,
                        error:
                          errors.has('licenseNum' + driver.id) ||
                          isDuplicateLicenseNum
                      }"
                      :name="'licenseNum' + driver.id"
                      @input="licenseNumChange"
                      placeholder="Driver's License Number"
                      v-model="driver.licenseNum"
                      v-validate="driver.DLValidation"
                      data-vv-validate-on="input|blur"
                    />
                    <span class="input__label">Driver's License Number</span>
                  </label>
                  <div
                    class="select-wrapper -spacing-static-c"
                    v-if="!driver.isExcluded.value"
                  >
                    <label
                      :for="'accidentsConvictions' + driver.id"
                      :class="{
                        error: errors.has('accidentsConvictions' + driver.id)
                      }"
                    >
                      Any at-fault accidents or convictions in the Last 3 years?
                    </label>
                    <v-select
                      v-model="driver.accidentsConvictions"
                      :searchable="false"
                      :options="selectsDrivers.accidentsConvictions"
                      v-validate="'required'"
                      :name="'accidentsConvictions' + driver.id"
                      :class="{
                        error: errors.has('accidentsConvictions' + driver.id)
                      }"
                    ></v-select>
                  </div>
                  <div
                    class="select-wrapper -spacing-static-c"
                    v-if="driver.id === form.drivers.length && !hasMaximum"
                  >
                    <label
                      :for="'addAnotherDriver' + driver.id"
                      :class="{
                        error: errors.has('addAnotherDriver' + driver.id)
                      }"
                    >
                      Would you like to add another driver to this policy?
                    </label>
                    <v-select
                      v-model="driver.addAnotherDriver"
                      :searchable="false"
                      :options="selectsDrivers.addAnotherDriver"
                      :name="'addAnotherDriver' + driver.id"
                      v-validate="'required'"
                      :class="{
                        error: errors.has('addAnotherDriver' + driver.id)
                      }"
                    ></v-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="
            hasMaximum &&
              id === form.drivers.length &&
              form.drivers[form.drivers.length - 1].maritalStatus !== 'Married'
          "
        >
          <p class="has-maximum">
            Please call
            <a :href="'tel:1-' + $phoneNumber">{{ $phoneNumber }}</a> and speak
            with an agent in order to add more drivers.
          </p>
        </div>
        <div class="button-right-align">
          <button
            @click="backToPrevious"
            type="button"
            v-if="currentStepNumber > 1 && currentStepNumber < 5"
            class="button-primary button-primary--black -spacing-static-b back-button"
          >
            <span class="button-primary__icon icon icon--arrow-right-hair">
              <span class="loader-base button-primary__loader"></span>
            </span>
            <span class="button-primary__label">Back</span>
          </button>

          <button
            @click="continueToNext"
            type="button"
            class="button-primary button-primary--black -spacing-static-b your-driver-continue-button"
            v-if="currentStepNumber !== 7"
          >
            <span class="button-primary__icon icon icon--arrow-right-hair">
              <span class="loader-base button-primary__loader"></span>
            </span>
            <span class="button-primary__label">{{
              isLastStep ? 'Submit' : 'Continue'
            }}</span>
          </button>

          <button
            @click="removeDriver(id - 1)"
            type="button"
            v-if="id > 1 && form.drivers[id - 1].relation !== 'Spouse'"
            class="button-primary button-primary--black -spacing-static-b remove-driver"
          >
            <span class="button-primary__icon icon icon--arrow-right-hair">
              <span class="loader-base button-primary__loader"></span>
            </span>
            <span class="button-primary__label">Remove Driver</span>
          </button>
        </div>
      </fieldset>
    </form>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapMutations } from 'vuex';
import { canUseAdvertising, safeGtag } from '@/utils/tracking';
import commonModal from '../shared/commonModal';
import moment from 'moment';
import * as _ from 'lodash';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';

export default {
  props: {
    wizardData: {
      type: Object,
      required: true
    },
    currentStepNumber: {
      type: Number
    },
    isLastStep: {
      type: Boolean
    }
  },
  components: {
    commonModal
  },
  data: () => ({
    id: 0,
    form: {
      drivers: [],
      previousCompany: null
    },
    occupationReadonly: false,
    validationOptions: {
      atleastEighteenYrsOld: new Date(
        new Date().setFullYear(new Date().getFullYear() - 18)
      ),
      atleastSixteenYrsOld: new Date(
        new Date().setFullYear(new Date().getFullYear() - 16)
      ),
      someOldDate: new Date(
        new Date().setFullYear(new Date().getFullYear() - 120)
      ),
      date: {
        date: true,
        datePattern: ['m', 'd', 'Y'],
        delimiter: '/'
      }
    },
    maximum: 4,
    hasMaximum: false,
    isPrimaryDriver: true,
    marriedSelected: false,
    showMoreInfoModal: false,
    isDuplicateLicenseNum: false,
    licenseStatusWarningModal: false,
    selectedDate: null,
    policyExpValidation: 'required',
    policyExpMinDate: new Date(),
    policyExpMaxDate: null,
    recentIssuerLabel: 'How long have you been with your current insurer?',
    occupationSelect: []
  }),

  mounted: function() {
    this.floodlightDrivers();
    if (!_.isEmpty(this.quoteForm.drivers)) {
      this.form.drivers = _.cloneDeep(this.quoteForm.drivers);
      const selectedAutoInsurance = {
        ...this.form.drivers[0].hasAutoInsurance
      };
      this.setPolicyExpDateLimits(selectedAutoInsurance, 0, true);
      this.scrollTop();
      this.id = this.form.drivers.length;
      if (
        this.form.drivers.length > 0 &&
        (!this.form.drivers[0].firstName || !this.form.drivers[0].lastName)
      ) {
        this.form.drivers[0].firstName = this.quoteForm.info.firstName;
        this.form.drivers[0].lastName = this.quoteForm.info.lastName;
      }
    } else {
      this.addDriver();
      this.isPrimaryDriver = false;
    }
  },
  computed: {
    ...mapGetters(['quoteForm', 'selectsDrivers']),
    occupationState() {
      return (
        this.quoteForm.info.state.value === 'AZ' ||
        this.quoteForm.info.state.value === 'CA' ||
        this.quoteForm.info.state.value === 'CO' ||
        this.quoteForm.info.state.value === 'FL' ||
        this.quoteForm.info.state.value === 'OH' ||
        this.quoteForm.info.state.value === 'PA' ||
        this.quoteForm.info.state.value === 'TN' ||
        this.quoteForm.info.state.value === 'TX' ||
        this.quoteForm.info.state.value === 'UT' ||
        this.quoteForm.info.state.value === 'WI'
      );
    },
    previousCompanySelects() {
      const storedCompanies = this.selectsDrivers[
        this.quoteForm.info.state.value
      ].previousCompany;

      let companyMap = storedCompanies.map(c => {
        return {
          label: c.carrier,
          value: c.carrier,
          indicator: c.indicator
        };
      });
      return companyMap;
    },
    industrySelects() {
      return this.selectsDrivers[
        this.quoteForm.info.state.value
      ].occupation.map(occ => {
        return {
          label: occ.industry,
          value: occ.industry
        };
      });
    },
    recentCoverageLimitsSelects() {
      const stateSelects = this.selectsDrivers[this.quoteForm.info.state.value];
      return stateSelects && stateSelects.recentCoverageLimits;
    },
    quoteFNameWatch() {
      return _.cloneDeep(this.quoteForm.info.firstName);
    },
    quoteLNameWatch() {
      return _.cloneDeep(this.quoteForm.info.lastName);
    },
    quoteDOBWatch() {
      return _.cloneDeep(this.quoteForm.info.dateOfBirth);
    },
    selectedStateWatch() {
      if (
        this.quoteForm.info.garagingState &&
        this.quoteForm.info.isGarageSameAsMailing.value !== 1
      ) {
        return this.quoteForm.info.garagingState.value;
      }
      return this.quoteForm.info.state ? this.quoteForm.info.state.value : '';
    },
    autoCorrectedDatePipe() {
      return createAutoCorrectedDatePipe('mm/dd/yyyy');
    }
  },
  methods: {
    ...mapMutations(['updateForm']),
    floodlightDrivers() {
      if (
        process.env.VUE_APP_ENV.toLowerCase() !== 'production' &&
        process.env.VUE_APP_ENV.toLowerCase() !== 'prod'
      ) {
        return;
      } else if (!canUseAdvertising()) {
        return;
      } else {
        // console.log('2025 Floodlight 3 Active');
        // Porsche PAI Receive a quote Form Continue Button 3.Your Drivers
        let flDiv = document.body.appendChild(document.createElement('div'));
        let GDPR = '${GDPR}';
        let GDPR_CONSENT_755 = '${GDPR_CONSENT_755}';
        flDiv.setAttribute('id', process.env.VUE_APP_FLOODLIGHT_ID);
        flDiv.style.position = 'absolute';
        flDiv.style.top = '0';
        flDiv.style.left = '0';
        flDiv.style.width = '1px';
        flDiv.style.height = '1px';
        flDiv.style.display = 'none';
        flDiv.innerHTML = `
            <img src="https://ad.doubleclick.net/ddm/activity/src=5368208;type=2025p0;cat=porsc001;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=1?" width="1" height="1" alt=""/>

          `;
        if (process.env.VUE_APP_GOOGLE_ANALYTICS === 'enable') {
          safeGtag('advertising', 'event', 'conversion', {
            allow_custom_scripts: true,
            send_to: 'DC-5368208/2025p0/porsc001+standard'
          });
        }
      }
    },
    industryChange(industry) {
      this.form.drivers[this.id - 1].occupation = null;
      this.occupationReadonly = false;
      this.occupationSelect = [];
      let results = [];
      if (
        this.form.drivers[this.id - 1] &&
        this.form.drivers[this.id - 1].occupationIndustry
      ) {
        this.form.drivers[this.id - 1].occupation = null;
        let ind = this.selectsDrivers[
          this.quoteForm.info.state.value
        ].occupation.find(obj => {
          return obj.industry === industry.value;
        });
        results = ind.occupations || [];
        if (results && results.length === 1) {
          this.form.drivers[this.id - 1].occupationCode = results[0].value;
          this.form.drivers[this.id - 1].occupation = results[0];
          this.occupationReadonly = true;
        }
        this.occupationSelect = results;
      }
    },
    occupationChange(occupation) {
      this.form.drivers[this.id - 1].occupation = occupation;
      this.form.drivers[this.id - 1].occupationCode = occupation.value;
    },
    addDriver() {
      // if (this.excludeSpouse === 'Yes') {
      //   this.maximum = 5;
      // } else {
      //   }
      this.maximum = 4;
      let driverWithoutSpouse = this.form.drivers.filter(driver => {
        return driver.relation !== 'Spouse';
      });
      if (
        driverWithoutSpouse.length < this.maximum ||
        (this.form.drivers[this.form.drivers.length - 1] &&
          this.form.drivers[this.form.drivers.length - 1].maritalStatus ===
            'Married') ||
        (this.form.drivers[this.id - 1].maritalStatus === 'Married' &&
          this.form.drivers[this.id].relation !== 'Spouse')
      ) {
        this.scrollTop();
        this.id++;
        if (this.id === 1) {
          this.form.drivers.push({
            id: this.id,
            name: 'Your Drivers',
            isPrimaryDriver: this.isPrimaryDriver,
            firstName: this.quoteForm.info.firstName,
            lastName: this.quoteForm.info.lastName,
            emailAddress: null,
            dateOfBirth: this.quoteForm.info.dateOfBirth,
            gender: null,
            relation: 'INSURED',
            maritalStatus: null,
            licenseState: null,
            licenseStatus: null,
            licenseNum: null,
            homeRentalStatus: null,
            levelOfEducation: null,
            previousExpirationDate: '',
            hasAutoInsurance: null,
            recentCoverageLimits: null,
            accidentsConvictions: null,
            showLengthWithInsurer: false,
            addAnotherDriver: null,
            DLValidation: 'required'
          });
        } else if (
          this.form.drivers[this.id - 2] &&
          this.form.drivers[this.id - 2].maritalStatus === 'Married'
        ) {
          this.form.drivers.splice(this.id - 1, 0, {
            id: this.id,
            name: this.id === 2 ? 'Your Spouse' : 'Additional Driver Spouse',
            isPrimaryDriver: this.id === 1 ? true : false,
            firstName: null,
            lastName: null,
            emailAddress: null,
            dateOfBirth: '',
            gender: null,
            relation: 'Spouse',
            maritalStatus: null,
            licenseState: null,
            licenseStatus: null,
            licenseNum: null,
            homeRentalStatus: null,
            levelOfEducation: null,
            ageReceivedLicense: null,
            hasAutoInsurance: null,
            recentCoverageLimits: null,
            accidentsConvictions: null,
            addAnotherDriver: null,
            isExcluded: this.selectsDrivers.excludeSpouseOptions[1],
            DLValidation: 'required'
          });
        } else if (
          this.form.drivers[this.id - 2] &&
          this.form.drivers[this.id - 2].maritalStatus === 'Married'
        ) {
          this.form.drivers.splice(this.id - 1, 0, {
            id: this.id,
            name: this.id === 2 ? 'Your Spouse' : 'Additional Driver Spouse',
            isPrimaryDriver: this.id === 1 ? true : false,
            firstName: null,
            lastName: null,
            emailAddress: null,
            dateOfBirth: '',
            gender: null,
            relation: 'Spouse',
            maritalStatus: null,
            licenseState: null,
            licenseStatus: null,
            licenseNum: null,
            homeRentalStatus: null,
            levelOfEducation: null,
            ageReceivedLicense: null,
            hasAutoInsurance: null,
            recentCoverageLimits: null,
            accidentsConvictions: null,
            addAnotherDriver: null,
            isExcluded: this.selectsDrivers.excludeSpouseOptions[1]
          });
        } else {
          this.form.drivers.push({
            id: this.id,
            name: 'Additional Driver',
            isPrimaryDriver: this.isPrimaryDriver,
            firstName: null,
            lastName: null,
            emailAddress: null,
            dateOfBirth: '',
            gender: null,
            relation: null,
            maritalStatus: null,
            licenseState: null,
            licenseStatus: null,
            licenseNum: null,
            homeRentalStatus: null,
            levelOfEducation: null,
            hasAutoInsurance: null,
            recentCoverageLimits: null,
            accidentsConvictions: null,
            addAnotherDriver: null,
            DLValidation: 'required'
          });
        }
        if (this.occupationState) {
          let driver = this.form.drivers.find(d => d.id === this.id);
          driver.occupationIndustry = null;
          driver.occupation = null;
        }
        this.syncIndex();
        if (
          driverWithoutSpouse.length + 1 === this.maximum &&
          this.form.drivers[this.form.drivers.length - 1].relation !== 'Spouse'
        ) {
          this.hasMaximum = true;
        }
      } else {
        this.hasMaximum = true;
      }
    },

    checkWorking(key, value) {
      let validator = this.$validator;
      validator.validate(key, value);
    },

    scrollTop() {
      let container = document.getElementById('quote-container');
      setTimeout(() => {
        container.scrollIntoView(true);
      }, 100);
    },

    continueToNext() {
      let that = this;
      this.validateFields()
        .then(() => {
          if (this.checkLicenseStatus(that.form.drivers[that.id - 1])) {
            return;
          }
          if (this.checkDuplicateLicenseNum()) {
            return;
          }
          if (
            that.form.drivers[that.id - 1].addAnotherDriver === 'Yes' ||
            that.form.drivers[that.id - 1].maritalStatus === 'Married'
          ) {
            that.scrollTop();
            if (
              that.id < that.form.drivers.length &&
              ((that.form.drivers[that.id - 1].addAnotherDriver === 'Yes' &&
                that.form.drivers[that.id].name &&
                that.form.drivers[that.id].name === 'Additional Driver') ||
                (that.form.drivers[that.id - 1].maritalStatus === 'Married' &&
                  that.form.drivers[that.id].relation &&
                  that.form.drivers[that.id].relation === 'Spouse'))
            ) {
              that.id++;
            } else {
              that.addDriver();
            }
          } else if (that.id < that.form.drivers.length) {
            that.id++;
          } else {
            that.$emit('nextButtonAction');
          }
        })
        .catch(error => console.log(error));
    },

    backToPrevious() {
      this.scrollTop();
      this.isDuplicateLicenseNum = false;
      if (this.id > 1) {
        this.id--;
      } else {
        this.$emit('goBack');
      }
    },

    showSnackBar(options) {
      this.$snackbar.open(options);
    },

    checkDuplicateLicenseNum() {
      let licenseArr = this.form.drivers.map(function(driver) {
        if (
          driver.relation !== 'Spouse' ||
          (driver.relation === 'Spouse' && !driver.isExcluded.value)
        ) {
          return driver.licenseNum;
        }
      });
      licenseArr = licenseArr.filter(function(element) {
        if (element !== null || element !== 'undefined') {
          return element;
        }
      });
      this.isDuplicateLicenseNum = licenseArr.some(function(item, idx) {
        return licenseArr.indexOf(item) != idx;
      });
      let errorField = this.$el.querySelector(
        '[name="licenseNum' + this.id + '"]'
      );
      if (this.isDuplicateLicenseNum) {
        errorField.focus();
        this.showSnackBar({
          type: 'is-danger',
          message: 'License number already added',
          position: 'is-bottom'
        });
        return true;
      }
      this.isDuplicateLicenseNum = false;
      return false;
    },

    validateFields() {
      let firstErrorField;
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then(result => {
          if (result) {
            resolve(true);
          } else {
            firstErrorField = this.$el.querySelector(
              '[name="' + this.$validator.errors.items[0].field + '"]'
            );
            firstErrorField.focus();
            reject('invalid fields');
          }
        });
      });
    },

    removeDriver: function(index) {
      this.scrollTop();
      this.isDuplicateLicenseNum = false;
      if (
        this.form.drivers[index].maritalStatus === 'Married' &&
        this.form.drivers.length > index
      ) {
        Vue.delete(this.form.drivers, index + 1);
      }
      Vue.delete(this.form.drivers, index);
      this.id--;
      this.form.drivers[this.id - 1].addAnotherDriver = 'No';
      this.syncIndex();
      this.hasMaximum = false;
    },

    syncIndex() {
      this.form.drivers.forEach(function(item, index) {
        item.id = index + 1;
      });
    },

    maritalStatusChanged(option) {
      if (option !== 'Married') {
        if (
          this.form.drivers.length > 1 &&
          this.form.drivers[this.id] &&
          this.form.drivers[this.id].relation === 'Spouse'
        ) {
          Vue.delete(this.form.drivers, this.id);
          this.syncIndex();
        }
      } else {
        this.form.drivers[this.id - 1].addAnotherDriver = 'No';
      }
    },

    licenseStateChanged(state) {
      this.form.drivers[this.id - 1].DLValidation =
        'required|DL#' + state.value;
    },

    setPolicyExpDateLimits(selectedAutoInsurance, index, fromMounted = false) {
      if (selectedAutoInsurance.value === 1 && index === 0) {
        if (!fromMounted) {
          this.form.drivers[index].previousExpirationDate = moment()
            .subtract(15, 'd')
            .format('MM/DD/YYYY');
        }
        this.policyExpValidation = 'required|isLeapYear|pastMonth';
        this.policyExpMinDate = moment()
          .subtract(31, 'd')
          .toDate();
        this.policyExpMaxDate = new Date();
        this.recentIssuerLabel = 'How long were you with your prior insurer?';
      } else {
        if (!fromMounted) {
          this.form.drivers[index].previousExpirationDate = '';
        }
        this.policyExpValidation = 'required|onlyFutureDate|isLeapYear';
        this.policyExpMinDate = new Date();
        this.policyExpMaxDate = null;
        this.recentIssuerLabel =
          'How long have you been with your current insurer?';
      }
    },

    autoInsuranceChanged(index) {
      const selectedAutoInsurance = {
        ...this.form.drivers[index].hasAutoInsurance
      };
      this.setPolicyExpDateLimits(selectedAutoInsurance, index);
      if (
        (selectedAutoInsurance.value === 1 ||
          selectedAutoInsurance.value === 3) &&
        index === 0
      ) {
        this.form.drivers[index].showLengthWithInsurer = true;
      } else {
        this.form.drivers[index].showLengthWithInsurer = false;
        this.form.drivers[index].previousExpirationDate = '';
      }
      if (
        (selectedAutoInsurance.value === 0 ||
          selectedAutoInsurance.value === 2) &&
        index === 0
      ) {
        delete this.form.drivers[index].recentCoverageLimits;
        delete this.form.drivers[index].recentIssuerLength;
      }
    },
    licenseNumChange() {
      this.form.drivers[this.id - 1].licenseNum = this.form.drivers[
        this.id - 1
      ].licenseNum
        .toString()
        .replace(/[^a-zA-Z0-9*]/g, '');
      if (this.isDuplicateLicenseNum) {
        this.isDuplicateLicenseNum = false;
      }
    },
    submit() {
      let firstErrorField;

      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then(result => {
          if (result) {
            let payload = {
              drivers: _.cloneDeep(this.form.drivers),
              info: {
                ...this.quoteForm.info,
                previousCompany: this.form.previousCompany
              }
            };
            this.updateForm(payload);
            resolve(true);
          } else {
            firstErrorField = this.$el.querySelector(
              '[name="' + this.$validator.errors.items[0].field + '"]'
            );
            firstErrorField.focus();
            reject('invalid fields');
          }
        });
      });
    },
    openMoreInfoModal() {
      this.showMoreInfoModal = true;
    },
    checkLicenseStatus(driver) {
      this.licenseStatusWarningModal = false;
      if (
        driver.licenseStatus &&
        (driver.licenseStatus.value === 'REVOKED' ||
          driver.licenseStatus.value === 'SUSPENDED')
      ) {
        if (driver.relation === 'Spouse' && driver.isExcluded.value) {
          return false;
        }
        this.licenseStatusWarningModal = true;
        return true;
      }
      return false;
    },
    changedDOB(event) {
      const incomingDateObject = moment(event).format('MM/DD/YYYY');
      this.form.drivers[this.id - 1].dateOfBirth = incomingDateObject;
      this.selectedDate = null;
      this.$el.querySelector('[name="dateOfBirth' + this.id + '"]').focus();
      this.$validator.validate('dateOfBirth' + this.id, incomingDateObject);
    },
    changedPreviousExpirationDate(event) {
      const incomingDateObject = moment(event).format('MM/DD/YYYY');
      this.form.drivers[
        this.id - 1
      ].previousExpirationDate = incomingDateObject;
      this.selectedDate = null;
      this.$el
        .querySelector('[name="previousExpirationDate' + this.id + '"]')
        .focus();
      this.$validator.validate(
        'previousExpirationDate' + this.id,
        incomingDateObject
      );
    }
  },
  watch: {
    quoteFNameWatch: {
      immediate: true,
      handler: function(newValue, oldValue) {
        if (
          newValue &&
          oldValue &&
          !_.isEqual(newValue, oldValue) &&
          this.form.drivers.length
        ) {
          this.form.drivers[0].firstName = newValue;
        }
      }
    },
    quoteLNameWatch: {
      immediate: true,
      handler: function(newValue, oldValue) {
        if (
          newValue &&
          oldValue &&
          !_.isEqual(newValue, oldValue) &&
          this.form.drivers.length
        ) {
          this.form.drivers[0].lastName = newValue;
        }
      }
    },
    quoteDOBWatch: {
      immediate: true,
      handler: function(newValue, oldValue) {
        if (
          newValue &&
          oldValue &&
          !_.isEqual(newValue, oldValue) &&
          this.form.drivers.length
        ) {
          this.form.drivers[0].dateOfBirth = newValue;
        }
      }
    },
    selectedStateWatch: {
      immediate: true,
      handler: function(newValue) {
        this.form.drivers.forEach(driver => {
          if (driver.gender.value === 'Unspecified') {
            driver.gender = null;
          }
        });
        if (newValue === 'OR') {
          if (this.selectsDrivers.gender.length === 2) {
            this.selectsDrivers.gender.push({
              label: 'Prefer not to say',
              value: 'Unspecified'
            });
          }
        } else {
          if (this.selectsDrivers.gender.length === 3) {
            delete this.selectsDrivers.gender[2];
            this.selectsDrivers.gender.length = 2;
          }
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  margin-top: 1rem;
}
.more-info-link {
  text-decoration: underline;
  color: gray;
  cursor: pointer;
}
@media (max-width: 560px) {
  .quote-wizard .button-primary + .button-primary {
    &.remove-driver {
      margin-left: 0;
      margin-top: 1rem;
    }
  }
}
</style>
